
function parseDateString(dateString) {
  const parts = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/);

  if (!parts) {
    throw new Error("Invalid date format. Expected yyyy-MM-dd HH:mm");
  }

  const [, year, month, day, hour, minute] = parts;

  return new Date(Date.UTC(year, month - 1, day, hour, minute));
}

function convertToTimezone(date, targetTimeZone) {
  
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: targetTimeZone
  };
  
  // 'sv-SE' é usado para garantir o formato yyyy-MM-dd
  const formatter = new Intl.DateTimeFormat('sv-SE', options);
  
  return formatter.format(date).replace(', ', ' ');
}

export function convertDatetimeStringToTimezone(datetimeString, targetTimeZone) {
  const date = parseDateString(datetimeString);
  const formattedDate = convertToTimezone(date, targetTimeZone);
  return formattedDate;
}